import { IconCloseRed } from "assets";
import { updateStatusPembayaran } from "config/Redux/action";
import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "..";

export default function PaymentHomecare({ closeModal, idPasien }) {
  const dispatch = useDispatch();

  const handleClickList = async () => {
    await dispatch(updateStatusPembayaran(`/staff/queues/${idPasien}`, 3));
    return closeModal();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center">
      <div
        className="w-auto max-h-full bg-white px-20 flex flex-col justify-center items-center relative"
        style={{ width: 512, height: 450 }}
      >
        <div className=" rounded-full border-4 border-red1  w-20 h-20 flex items-center justify-center">
          <img src={IconCloseRed} alt="" className="w-6 h-6 " />
        </div>

        <p className="font-inter font-bold text-2xl my-8">
          Pembayaran Langsung, Sudah Terima Pembayaran ?
        </p>

        <div className="flex">
          <Button
            isBtnOutlineSecondary
            title="Kembali"
            className="rounded-3 mr-9 text-gray1"
            onClick={() => closeModal()}
          />
          <Button
            isPrimary
            title="Ya, Pembayaran Diterima"
            className="rounded-3 bg-blue1 border border-blue1 hover:border-blue1 hover:bg-blue1"
            onClick={handleClickList}
          />
        </div>
      </div>
    </div>
  );
}
